import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { isEmpty } from 'lodash';
import { ENTITY_TYPES } from '../types/enums/entityTypes.enum';
import { getSingularEntityName } from '../configs/entity-name-config';
import { I18n } from '@app/i18n/strings-keys';
import { XVII18nService } from '@app/i18n/services';

const getEntityNameRequiredValidator = (
  entity: ENTITY_TYPES,
  i18nService: XVII18nService,
): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const controlValue = control.value;

    return !isEmpty(controlValue)
      ? null
      : {
          error: i18nService.instant(I18n.Common.EnterANameForEntity, {
            entityName: i18nService.instant(getSingularEntityName(entity)),
          }),
        };
  };
};

export { getEntityNameRequiredValidator };
